// src/services/feedbackService.js

import api from "../api/api";

export const sendFeedback = async (payload) => {
    try {
        const response = await api.post("/feedback", {
            name: payload.name?.trim() || "",
            email: payload.email?.trim() || "",
            message: payload.message?.trim() || "",
            cityId: Number(payload.cityId),
        });

        return response.data;
    } catch (err) {
        console.error("Error sending feedback:", err);

        const validationErrors =
            err?.response?.data?.errors;

        if (validationErrors) {
            const messages = Object.values(
                validationErrors
            )
                .flat()
                .filter(Boolean);

            if (messages.length > 0) {
                throw new Error(
                    messages.join(" ")
                );
            }
        }

        const message =
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message ||
            "Failed to send feedback.";

        throw new Error(message);
    }
};

export default {
    sendFeedback,
};